import { Nullable, Nullish, Uuid } from './common';

export enum FileType {
  ID = 'ID',
  SELFIE = 'SELFIE',
}

export enum InvoiceStatus {
  CONFLICT = 'CONFLICT',
  ERROR = 'ERROR',
  EXPIRED = 'EXPIRED',
  PAID = 'PAID',
  PENDING = 'PENDING',
}

export enum PaymentMethod {
  CARD = 'CARD',
  FRANCOPHONE = 'FRANCOPHONE',
}

export enum PaymentStatus {
  AWAITING_3DS = 'AWAITING_3DS',
  AWAITING_AVS = 'AWAITING_AVS',
  AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION',
  AWAITING_OTP = 'AWAITING_OTP',
  AWAITING_PIN = 'AWAITING_PIN',
  CREATED = 'CREATED',
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

export enum ProfileStatus {
  APPROVED = 'APPROVED',
  PERSONAL_INFO_REQUIRED = 'PERSONAL_INFO_REQUIRED',
  REJECTED = 'REJECTED',
  SUSPENDED = 'SUSPENDED',
  TERMINATED = 'TERMINATED',
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
}

export enum WithdrawalMethod {
  BANK_TRANSFER = 'BANK_TRANSFER',
}

export enum WithdrawalSchedule {
  IMMEDIATELY = 'IMMEDIATELY',
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum WithdrawalStatus {
  CREATED = 'CREATED',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
}

export type Balance = {
  balance: number;
  currency: CurrencyCode;
};

export type Country = {
  code: CountryCode;
  name: string;
};

export type CountryCode = string;

export type CurrencyCode = string;

export type Invoice = {
  id: Uuid;
  displayId: string;
  amount: number;
  currency: CurrencyCode;
  purpose: string;
  status: InvoiceStatus;
  createdDate: string;
  updatedDate: string;
  client: {
    id: Uuid;
    companyName: Nullable<string>;
    email: string;
  };
  payments: Array<{
    trxRef: string;
    email: string;
    amount: number;
    fee: number;
    currency: CurrencyCode;
    purpose: string;
    errorMessage?: Nullish<string>;
    redirectUrl?: Nullish<string>;
    type: PaymentMethod;
    status: PaymentStatus;
    createdDate: string;
    updatedDate: string;
  }>;
};

export type InvoiceBasic = {
  displayId: string;
  amount: number;
  currency: CurrencyCode;
  purpose: string;
  createdDate: string;
};

export type Payout = {
  id: Uuid;
  type: WithdrawalMethod;
  amount: number;
  feeAmount: number;
  currency: {
    code: CurrencyCode;
    decimals: number;
  };
  status: WithdrawalStatus;
  createdDate: string;
  updatedDate: string;
};

export type Profile = {
  name: string;
  companyName: string;
  countryCode: string;
  email: string;
  phone: string;
  status: ProfileStatus;
};

export type UploadedFile = {
  type: FileType;
  name: string;
};

export type Withdrawal = {
  id: Uuid;
  withdrawalMethod: Nullable<WithdrawalMethod>;
  schedule: WithdrawalSchedule;
  createdDate: string;
  updatedDate: string;
  details: {
    bankCode?: Nullish<string>;
    accountNumber?: Nullish<string>;
  };
};
